import { CommonModule } from '@angular/common';
import { HostListener, NgModule } from '@angular/core';
import { FooterModule } from '@components/ui/footer/footer.module';
import { HeaderModule } from '@components/ui/header/header.module';
import { SidebarModule } from "@components/ui/sidebar/sidebar.module";
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { LayoutComponent } from './layout.component';
import { WavesJsComponent } from './waves-js/waves-js.component';

@NgModule({
  declarations: [],
  imports: [LayoutComponent, WavesJsComponent, CommonModule, HeaderModule, FooterModule, NzLayoutModule, SidebarModule],
  exports: [LayoutComponent],
})
export class LayoutModule {
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.initHeightForResize();
  }

  private initHeightForResize() {
    // do nothing
  }
}
